module.exports = __webpack_public_path__ + "static/media/glitter_silver.d6d37543.png";